import { useEffect, useRef } from 'react';
import { ENTER_KEY_CODE } from '@sdk/common/constants';
import { useFocused } from 'slate-react';

type Props = {
  isSubmitActive: boolean;
  submit: () => void;
  submitOnEnter: boolean;
};

export function useEditorEnterPress({ isSubmitActive, submit, submitOnEnter }: Props): void {
  const functionRef = useRef<any>();
  const isFocused = useFocused();

  useEffect(() => {
    functionRef.current = (event: KeyboardEvent): void => {
      if (
        submitOnEnter &&
        isFocused &&
        event.which === ENTER_KEY_CODE &&
        event.shiftKey === false
      ) {
        event.preventDefault();

        if (isSubmitActive) {
          submit();
        }
      }
    };

    document.addEventListener('keydown', functionRef.current, { capture: true });

    return (): void =>
      document.removeEventListener('keydown', functionRef.current, { capture: true });
  }, [isFocused, isSubmitActive, submit, submitOnEnter]);
}
